import React, {Component} from "react"
import {Link} from "react-router-dom"

export default class ListItemDeliveryNote extends Component {
  render() {
    return (
      <div className="sh-list-item">
        <div className={"content"}>
          <Link to={`/delivery_notes/${this.props.number}`}>
            <div className="primary">{this.props.number}</div>
          </Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemDeliveryNote.js